export default __webpack_public_path__ + "static/og_image-1193ec7c86c6e44cd9772dc11021684f.jpg";